if (!window.ProductQuantitySelector) {
  class ProductQuantitySelector extends HTMLElement {
    productId = null;
    shouldPropagateChange = false;
    variantSelectorFallback =
      '.product__right-outer #productFormSelector option[selected="true"]';

    constructor() {
      super();
      this._boundHandleInputChange = this._handleInputChange.bind(this);
      this._boundHandleDecrease = this._handleDecrease.bind(this);
      this._boundHandleIncrease = this._handleIncrease.bind(this);
    }

    connectedCallback() {
      const input = this.querySelector(".quantity__input");
      const decreaseBtn = this.querySelector(".quantity__decrease");
      const increaseBtn = this.querySelector(".quantity__increase");

      this.productId = this.dataset.productId;
      this.shouldPropagateChange =
        this.dataset.shouldPropagateChange === "true";

      if (!input) return;

      input.addEventListener("change", this._boundHandleInputChange);

      if (decreaseBtn) {
        decreaseBtn.addEventListener("click", this._boundHandleDecrease);
      }
      if (increaseBtn) {
        increaseBtn.addEventListener("click", this._boundHandleIncrease);
      }
    }

    disconnectedCallback() {
      const input = this.querySelector(".quantity__input");
      const decreaseBtn = this.querySelector(".quantity__decrease");
      const increaseBtn = this.querySelector(".quantity__increase");

      if (input)
        input.removeEventListener("change", this._boundHandleInputChange);
      if (decreaseBtn)
        decreaseBtn.removeEventListener("click", this._boundHandleDecrease);
      if (increaseBtn)
        increaseBtn.removeEventListener("click", this._boundHandleIncrease);
    }

    getMaxQty() {
      const option = document.querySelector(this.variantSelectorFallback);
      if (option && option.dataset.invqty != null) {
        return parseInt(option.dataset.invqty, 10) || 1;
      }
      const dataMax = this.dataset.invQty ?? this.dataset.invqty;
      return dataMax != null ? parseInt(String(dataMax), 10) || 1 : 1;
    }

    _getInput() {
      return this.querySelector(".quantity__input");
    }

    _propagateQuantity(value) {
      if (!this.shouldPropagateChange || !this.productId) return;

      const others = document.querySelectorAll("product-quantity-selector");

      others.forEach((el) => {
        if (el !== this && el.productId === this.productId) {
          const input = el.querySelector(".quantity__input");
          if (input && String(input.value) !== String(value)) {
            input.value = value;
          }
        }
      });
    }

    _handleDecrease() {
      const input = this._getInput();
      if (!input) return;
      const next = parseInt(input.value, 10) - 1;
      input.value = Math.max(1, next);
      this._propagateQuantity(input.value);
    }

    _handleIncrease() {
      const input = this._getInput();
      if (!input) return;
      const max = this.getMaxQty();
      const next = parseInt(input.value, 10) + 1;
      input.value = Math.min(max, next);
      this._propagateQuantity(input.value);
    }

    _handleInputChange(e) {
      const input = e.target;
      const max = this.getMaxQty();
      const val = parseInt(input.value, 10);
      if (isNaN(val) || val < 1) {
        input.value = 1;
      } else if (val > max) {
        input.value = max;
      }
      this._propagateQuantity(input.value);
    }
  }

  window.ProductQuantitySelector = ProductQuantitySelector;

  if (!customElements.get("product-quantity-selector")) {
    customElements.define("product-quantity-selector", ProductQuantitySelector);
  }
}
